<template>
<div class="chapter">
<div class="inner_page">
<div class="pagebreak">
</div>
<p class="tocchaptitle"><a id="toc"></a>Simple Pleasures <i>of</i> Friendship</p>
<p class="toc"><a href="#/06_acknowledgments#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/07_indelibly#ieioh">Indelibly Etched in Our Hearts</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="center"><img alt="Image" src="images/ch1-01.jpg"/></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/08_chapter01#c1">F<span class="small">UN AND</span> F<span class="small">ROLIC</span></a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="center"><img alt="Image" src="images/ch2-01.jpg"/></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><span href="#/09_chapter02#c2" title="Link target outside of Sample">C<span class="small">OMFORT AND</span> C<span class="small">ARING</span></span></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="center"><img alt="Image" src="images/ch3-01.jpg"/></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><span href="#/10_chapter03#c3" title="Link target outside of Sample">L<span class="small">OVE AND</span> L<span class="small">EARNING</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_tableofcontents.vue?6864be5e